import { ThemeProvider } from "@material-ui/styles";
import { createBrowserHistory } from "history";
import { SnackbarProvider } from "notistack";
import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import GraphQlProvider from "./graphql/GraphQlProvider";
import I18nProvider from "./i18n/I18nProvider";
import Routes from "./Routes";
import theme from "./theme";
import { initChartJS } from "./utils/chartjs";
import DateUtilsProvider from "./components/DateUtilsProvider/DateUtilsProvider";
import { getHost } from "./graphql/GraphQlProvider";
import { FeatureFlag } from "./graphql/features";

initChartJS();

const history = createBrowserHistory();

export const FeatureContext = React.createContext<FeatureFlag[]>([]);

const App = () => {
    const [features, setFeatures] = React.useState<FeatureFlag[]>([]);
    React.useEffect(() => {
        const url = getHost() + "/graphql";
        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                query: `{
                    features {
                        name
                        slug
                        enabled
                    }
                }`
            })
        })
            .then(res => res.json())
            .then(res => {
                const { data } = res;
                setFeatures(data.features);
            })
            .catch(err => {
                console.error(err);
            });
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <GraphQlProvider>
                <I18nProvider>
                    <DateUtilsProvider>
                        <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
                            <FeatureContext.Provider value={features}>
                                <Router history={history}>
                                    <LastLocationProvider>
                                        <Routes />
                                    </LastLocationProvider>
                                </Router>
                            </FeatureContext.Provider>
                        </SnackbarProvider>
                    </DateUtilsProvider>
                </I18nProvider>
            </GraphQlProvider>
        </ThemeProvider>
    );
};

ReactDOM.render(<App />, document.getElementById("root"));

export default App;
